var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgIconMasterData = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53345 8.7403H9.10011C9.91678 8.7403 10.6168 8.04107 10.6168 7.22532V4.6615H10.5001L6.53345 8.7403Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53345 8.7403V18.2963C6.53345 19.1121 7.23345 19.8113 8.05011 19.8113H16.5668C17.3834 19.8113 18.0834 19.1121 18.0834 18.2963V6.17648C18.0834 5.36072 17.3834 4.6615 16.5668 4.6615H10.7334H10.6168V7.22532C10.6168 8.04107 9.91678 8.7403 9.10011 8.7403H6.53345Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53345 8.7403V18.2963C6.53345 19.1121 7.23345 19.8113 8.05011 19.8113H15.7501C16.5668 19.8113 17.2668 19.1121 17.2668 18.2963V6.17648C17.2668 5.36072 16.5668 4.6615 15.7501 4.6615H10.7334H10.6168V7.22532C10.6168 8.04107 9.91678 8.7403 9.10011 8.7403H6.53345Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2334 7.5749L13.6501 8.5072C13.3001 9.08989 12.7167 9.4395 12.0167 9.4395H6.53341C5.48341 9.4395 4.66675 10.2553 4.66675 11.3041V21.3263C4.66675 22.3751 5.48341 23.3074 6.53341 23.3074H21.0001C22.0501 23.3074 23.3334 22.4917 23.3334 21.4428V8.62374C23.3334 7.5749 22.5167 6.75915 21.4667 6.75915H15.8667C15.1667 6.64261 14.5834 6.99222 14.2334 7.5749Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7002 8.50717L15.2835 7.57487C15.6335 6.99219 16.2168 6.64258 16.9168 6.64258H15.8668C15.1668 6.64258 14.5835 6.99219 14.2335 7.57487L13.6502 8.50717C13.3002 9.08986 12.7168 9.43947 12.0168 9.43947H13.0668C13.7668 9.43947 14.3502 9.08986 14.7002 8.50717Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71675 21.3262V11.304C5.71675 10.2552 6.53341 9.43945 7.58341 9.43945H6.53341C5.48341 9.43945 4.66675 10.2552 4.66675 11.304V21.3262C4.66675 22.3751 5.48341 23.3074 6.53341 23.3074H7.58341C6.53341 23.3074 5.71675 22.3751 5.71675 21.3262Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7501 17.364H8.28346C7.8168 17.364 7.4668 17.0144 7.4668 16.5482V12.4694C7.4668 12.0033 7.8168 11.6537 8.28346 11.6537H15.7501C16.2168 11.6537 16.5668 12.0033 16.5668 12.4694V16.5482C16.6835 17.0144 16.2168 17.364 15.7501 17.364Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51685 13.4018C8.51685 13.0522 8.75018 12.8191 9.10018 12.8191H14.9335C15.2835 12.8191 15.5168 13.0522 15.5168 13.4018C15.5168 13.6349 15.2835 13.9845 14.9335 13.9845H9.10018C8.75018 13.9845 8.51685 13.6349 8.51685 13.4018Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51685 15.7325C8.51685 15.3829 8.75018 15.1498 9.10018 15.1498H14.9335C15.2835 15.1498 15.5168 15.3829 15.5168 15.7325C15.5168 16.0821 15.2835 16.3152 14.9335 16.3152H9.10018C8.75018 16.3152 8.51685 15.9655 8.51685 15.7325Z",
    fill: "url(#paint8_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2,
    y: -1,
    width: 32,
    height: 31.9689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.38033,
    y1: 4.74068,
    x2: 9.39879,
    y2: 8.02431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.12408,
    y1: 12.4519,
    x2: 23.2815,
    y2: 11.9154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.8997,
    y1: -1.8344,
    x2: 10.7081,
    y2: 20.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 4.66675,
    y1: 14.9736,
    x2: 23.3334,
    y2: 14.9736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414298,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7869,
    stopColor: "#F56D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 13.0591,
    y1: 5.32559,
    x2: 14.26,
    y2: 7.65719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414298,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7869,
    stopColor: "#F56D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 2.59288,
    y1: 16.2563,
    x2: 7.3684,
    y2: 16.3293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414298,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7869,
    stopColor: "#F56D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 10.9731,
    y1: 5.4165,
    x2: 12.8161,
    y2: 21.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 3.59865,
    y1: 8.39115,
    x2: 14.7509,
    y2: 14.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 2.58271,
    y1: 10.1104,
    x2: 13.735,
    y2: 16.7007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 18.6459,
    fill: "white",
    transform: "translate(4.66675 4.6615)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMasterData, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconMasterData.e7bb66b5.svg";
export { ForwardRef as ReactComponent };